import React from "react";
import { ImageItem } from "@kontent-ai/gatsby-components/dist/image-element";

export interface LinkedImageProps {
  image: { value: [ImageItem] };
  url: { value: string };
}

const LinkedImage = ({ image, url }: LinkedImageProps) => {
  return (
    <figure>
      <a href={url.value}>
        <img src={image.value[0].url} />
      </a>
    </figure>
  );
};

export default LinkedImage;
